/* global require */
'use_strict';

/**
 * Manages site wide navigation scripts.
 */
export class SiteNavigation {

    constructor() {
        if (window.innerWidth < 767) {
            window.onload = () => {
                this.handle_mobile_navigation();
            }
        }
    }

    /**
     * Handle the mobile navigation for better UX.
     * 
     * @returns {void}
     */
    handle_mobile_navigation() : void {
        const nav_background = document.querySelector('ul.cm-responsive-menu') as HTMLElement;
        const main_container = document.querySelector('#tygh_main_container') as HTMLElement;
        nav_background.style.height = main_container.offsetHeight + 'px';
    }
}

/**
 * Initialize the site wide navigation class.
 * @return {void}
 */
export function init_site_navigation() {
    if (document.getElementsByClassName('cm-external-triggered')[0]) {
        (() => new SiteNavigation())();
    }
}